import React, {useState, useEffect,useContext} from 'react';
import { useTranslate } from 'react-redux-multilingual';
import axios from 'axios';
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';
import SupplementListItem from './SupplementListComp/SupplementListItem';

const useLoad = (props) => {
    const t = useTranslate();
    const [loading,setLoading]=useState(false)
    const [reload,setReload]=useState(Date.now())

    // charge les infos d'un article a chaque changement d'id ou reload
    useEffect(function () {
        if (props.editArticleId) {
            (async function() {
                setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/get_article_supplement_list/"+props.editArticleId
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                    }
                    else{   
                        props.setDataNextList(response.data.data)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    swal.fire(t('unknowError'), "", "error");
                })
                // setLoading(false)
            })()
        }
    }, [props.editArticleId,reload])
    
    return [loading,setLoading,setReload]
}

const ModalSelectionSupplementList = (props) =>{
    const t = useTranslate(); //Traduction
    const { authParam } = useContext(IsAuthContext); //AuthParams

    const [loading,setLoading,setReload] = useLoad(props) //useLoad

    // Enregistrement des sélections et de leur ordre
    const [selectedSupplement,setSelectedSupplement] = useState({}) 
    const [selectionPath,setSelectionPath] = useState([]) 

    // Liste à afficher
    const [showList,setShowList] = useState(false)

    const [multipleData,setMultipleData] = useState([]) // Stockage de la sélection en cours de la validation pour les liste a choix multiple

    // Logique pour le choix de la liste à afficher en fonction de la priorité
    useEffect(function () {
        if (Object.keys(props.dataNextList).length>0) {
            let supplement_list = props.dataNextList.supplement_list

            if (supplement_list && Object.keys(supplement_list).length>0) {

                // Trie de la liste des supplément en fonction de l'ordre
                let orderSupplementList = supplement_list.sort((a,b) => {
                    if (a.order == null) return 1;
                    if (b.order == null) return -1;
                    return a.order - b.order
                })

                // Sélection de la liste à afficher
                if (orderSupplementList.length > 0) {
                    const articleSelections = selectedSupplement[props.editArticleId] || {};

                    // On cherche une liste soit non présente, soit vide (pas de supplément sélectionné)
                    const list = orderSupplementList.find(listItem => {
                        const selectedList = articleSelections[listItem.id];
                        return !selectedList || selectedList.length === 0;
                    });

                    // Validation finale modal
                    if (props.editArticleId==props.articleId && !list) {
                        props.validModal(props.articleId, selectedSupplement, selectionPath)
                    }
                    else if (!list) {
                        if (showList) {
                            getPreviousAndContinue()
                        }
                    }
                    else {
                        setLoading(false)
                    }

                    setShowList(list);
                }
            }
            else {
                setLoading(false)
                // Si l'article est le dernier du chemin on retourne au parent
                if (showList) {
                    getPreviousAndContinue()
                }
            }
        }
    }, [props.dataNextList])

    const resetList = () =>{
        props.setDataNextList([])
        setReload(Date.now())
        props.setEditArticleId(props.articleId)
        setSelectedSupplement({})
        setSelectionPath([])
        setMultipleData([])
    }

    // Ajout d'un article ou d'une quantité pour un choix multiple dans multipleData
    const addMultipleData = (article) => {
        if (multipleData.some(value => value.supplementId==article.id)) {
            setMultipleData(prev => 
                multipleData.map((value) => {
                    if (value.supplementId==article.id) {
                        // Contrôle quantité a jouter si configuration de max sur le supplement_list_detail
                        let newQuantity = value.quantity
                        const supplementDetail = showList.supplement_list_detail.find(detail => detail.article_id==article.id)
                        if ((supplementDetail?.max_quantity && newQuantity+1<=supplementDetail.max_quantity) || !supplementDetail?.max_quantity) newQuantity++
                        return {...value,quantity:newQuantity}
                    }
                    else {
                        return value
                    }
                })
            )
        }
        else {
            setMultipleData(prev => [
                ...prev,{supplementId:article.id,quantity:1}
            ])
        }
    }

    // supression d'un article pour un choix multiple dans multipleData
    const removeMultipleData = (article) => {
        setMultipleData(prev => 
            prev.filter(value => value.supplementId!=article.id)
        )
    }

    // Déclenché au clic sur un article
    const action = (article,multiple_choice=true) =>{  
        const listId = showList.id
        const articleId = props.editArticleId
        if (article) { // Si on sélectionne un article
            if (multiple_choice) {
                addMultipleData(article)
            }
            else {
                const supplementId = article.id
        
                addSupplementSelection(articleId, listId, supplementId, 1)
        
                setSelectionPath(prev => [
                    ...prev,
                    { listId, supplementId,  parentArticleId: articleId, article: props.dataNextList}
                ]);
                
                props.setEditArticleId(supplementId);
            }
        }
        else { // Si on sélectione l'option "pas de sélection"
            const supplementId = false

            addSupplementSelection(articleId, listId, supplementId, 1)
    
            setSelectionPath(prev => [
                ...prev,
                { listId, supplementId,  parentArticleId: articleId, article: props.dataNextList}
            ]);
            
            setReload(Date.now())
        }
    }

    // Appeler par le bouton de validation pour valider les sélections multiples
    const validateSelection = () => {
        const supplementIdList = multipleData.map((value) => {
            return value.supplementId
        })

        setSelectedSupplement(prev => {
            const articleSupps = prev[props.editArticleId] || {};

            let newList;
            if (supplementIdList.length>0) {
                newList = supplementIdList.map((id) => {
                    const quantity=(multipleData.find((value) => value.supplementId==id)).quantity
                    return {supplementId:id,quantity}
                })
            }
            else {
                newList = [{supplementId:false, quantity:1}]
            }

            return {
                ...prev,
                [props.editArticleId]: {
                    ...articleSupps,
                    [showList.id]: newList
                }
            };
        });

        setSelectionPath(prev => [
            ...prev,
            { listId:showList.id, supplementId:(supplementIdList.length>0) ? supplementIdList : false,  parentArticleId: props.editArticleId, article: props.dataNextList}
        ]);

        setMultipleData([])

        setReload(Date.now())
    }

    const resetAction = (article) => {
        removeMultipleData(article)
    }

    const getPreviousList = () =>{
        if (selectionPath.length == 0) {
            resetList();
            return;
        }

        const last = selectionPath[selectionPath.length - 1];

        // On retourne une étape en arrière dans le path
        const newPath = selectionPath.slice(0, -1);
        setSelectionPath(newPath);

        // On supprime la dernière sélection
        removeSupplementSelection(last.parentArticleId,last.listId,last.supplementId)

        if (last.parentArticleId) {
            props.setEditArticleId(last.parentArticleId);
            if (props.dataNextList && props.dataNextList.supplement_list) {
                const prevList = props.dataNextList.supplement_list.find(l => l.id === last.listId);
                setShowList(prevList || false);
            }
            setMultipleData([])
        } else {
            resetList(); // cas extrême : aucun parent défini
        }
    }

    const getPreviousAndContinue = () => {
        if (selectionPath.length == 0) {
            resetList();
            return;
        }

        let newPath = [...selectionPath];
        let current = newPath.pop();

        while (current) {
            // Remonter au parent
            if (current.parentArticleId) {
                // Vérifier si ce parent a plusieurs listes à compléter
                const parentSelections = selectedSupplement[current.parentArticleId] || {};
                const parentData = current.article; // ou récupérer la data correspondante à parentArticleId

                // Hypothèse : tu peux ici vérifier si le parent a plusieurs listes non complètes
                const supplement_list = parentData?.supplement_list || [];
                const listsIncomplete = supplement_list.some(listItem => {
                    const sel = parentSelections[listItem.id];
                    return !sel || sel.length == 0;
                });

                if (newPath.length==0) props.setEditArticleId(props.articleId)

                if (listsIncomplete) {
                    // On s'arrête ici
                    props.setEditArticleId(current.parentArticleId);
                    return;
                } else {
                    // Remonter encore plus haut
                    current = newPath.pop();
                }
            } else {
                resetList();
                return;
            }
        }
    };

    // Ajouter une sélection
    const addSupplementSelection = (articleId, listId, supplementId, quantity) => {
        setSelectedSupplement(prev => {
            const articleSupps = prev[articleId] || {};
            const listSupps  = articleSupps[listId] || [];

            const existing = listSupps.find(item => item.supplementId === supplementId);

            let newList;
            if (existing) {
                newList = listSupps.map(item =>
                    item.supplementId === supplementId
                    ? { ...item, quantity }
                    : item
                );
            } else {
                newList = [...listSupps, { supplementId, quantity }];
            }

            return {
                ...prev,
                [articleId]: {
                    ...articleSupps,
                    [listId]: newList
                }
            };
        });
    };

    // Supprimer une sélection
    const removeSupplementSelection = (articleId, listId, supplementId) => {
        setSelectedSupplement(prev => {
            const articleSupps = prev[articleId];
            if (!articleSupps || !articleSupps[listId]) return prev;

            let newList = []
            if (!Array.isArray(supplementId)) {
                newList = articleSupps[listId].filter(item => item.supplementId !== supplementId);
            }
            
            return {
                ...prev,
                [articleId]: {
                    ...articleSupps,
                    [listId]: newList
                }
            };
        });
    };

    return(<>
        <div className="row align-items-center">
            <div className="col">
                {(Object.keys(selectionPath).length>0) &&
                    <>
                        <button disabled={loading} className="btn btn-sm btn-warning mb-1" onClick={()=>resetList()}>Reset</button>&nbsp;&nbsp;
                        <button disabled={loading} className="btn btn-sm btn-dark mb-1" onClick={()=>getPreviousList()}>{t('btnBack')}</button>&nbsp;&nbsp;
                    </>
                }
                {showList && showList.multiple_choice &&
                    <>
                        <button disabled={loading} className="btn btn-sm btn-success mb-1" onClick={()=>validateSelection()}>{t('btnNextStep')}</button>&nbsp;&nbsp;
                    </>
                }
            </div>
        </div>
        {(loading) ?
            <div className="text-center"><div className="spinner-border spinner-border-sm"></div></div>
        :
            <>
                {(showList) ?
                    <>
                        <SupplementListItem
                            key={showList.id}
                            supplementList={showList}
                            action={action}
                            from={props.from}
                            resetAction={resetAction}
                            multipleData={multipleData}
                        />
                    </>
                :
                    false
                }
            </>
        }
    </>)
}

export default ModalSelectionSupplementList;